module.exports = __webpack_public_path__ + "img/10_44.3dc9ed02.png";